<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>

    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="submitData()">
      <div class="card-body">

        <!-- current image preview (update mode) -->
        <div v-if="dataRow && dataRow.image" class="row mb-3">
          <div class="col-12 col-sm-6 text-center">
            <p class="form-label text-start">الصورة الحالية:</p>
            <img :src="MEDIA_URL + dataRow.image" class="img-thumbnail" style="max-width:220px;" alt="">
          </div>
        </div>

        <div class="row">
          <!-- image upload -->
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">
              صورة الغلاف:
              <span v-if="dataRow" class="text-muted small">(اتركه فارغاً إذا لا تريد التغيير)</span>
              <span v-else class="text-danger">*</span>
            </label>
            <input type="file" accept="image/*" class="form-control" @change="setImage($event.target.files)">
          </div>

          <!-- title -->
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">عنوان النشرة: <span class="text-danger">*</span></label>
            <input type="text" v-model="title" class="form-control" placeholder="مثال: نشرة عقارية - يناير 2026">
          </div>
        </div>

        <div class="row">
          <!-- publish date -->
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">تاريخ النشر: <span class="text-danger">*</span></label>
            <input type="date" v-model="publishDate" class="form-control">
          </div>

          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">حالة النشرة:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div>

        <div class="row">
          <!-- pdf upload -->
          <div class="col-12 mb-3">
            <label class="form-label">
              ملف PDF:
              <span v-if="dataRow" class="text-muted small">(اتركه فارغاً إذا لا تريد التغيير)</span>
              <span v-else class="text-danger">*</span>
            </label>
            <!-- current pdf link in update mode -->
            <div v-if="dataRow && dataRow.pdfFile" class="mb-2">
              <a :href="MEDIA_URL + dataRow.pdfFile" target="_blank" class="btn btn-outline-secondary btn-sm">
                <i class="bi bi-file-earmark-pdf me-1"></i> عرض الملف الحالي
              </a>
            </div>
            <input type="file" accept="application/pdf" class="form-control" @change="setPdf($event.target.files)">
          </div>
        </div>

      </div>

      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast } from '@/helpers/tools';

export default {
  name: 'LatestNewsForm',
  props: {
    cardTitle: { type: String, default: 'إضافة' },
    dataRow: { type: Object, default: null },
  },
  data() {
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: '',
      publishDate: '',
      isActive:    true,
      image: null,
      pdfFile: null,
    };
  },
  computed: {
    ...mapGetters(['MEDIA_URL']),
  },
  methods: {
    setImage(files) { this.image   = files[0]; },
    setPdf(files) { this.pdfFile = files[0]; },

    submitData() {
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      const formData = new FormData();
      formData.append('title', this.title);
      formData.append('publishDate', this.publishDate);
      formData.append('isActive', this.isActive);
      if (this.image) formData.append('image',   this.image);
      if (this.pdfFile) formData.append('pdfFile', this.pdfFile);

      let api = null;
      if (this.dataRow)
        api = this.$http.put(`/api/admin/latestNews/update/${this.dataRow.id}`, formData);
      else
        api = this.$http.post('/api/admin/latestNews/create', formData);

      api.then(() => {
        if (!this.dataRow) {
          toast('تم الإضافة بنجاح', 'success');
          this.$router.replace('/latestNews').catch(() => {});
        } else {
          this.message  = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created() {
    if (this.dataRow) {
      this.title = this.dataRow.title;
      this.publishDate = this.dataRow.publishDate;
      this.isActive = this.dataRow.isActive;
    }
  },
};
</script>